﻿import {isObject, postData, postDataForm} from "./utils";

$(function () {
    $.Cart = {
        cart: {},
        currentItem: {},
        currentProductId: {},
        types: {Dialog: "dialog", CartButton: "cartButton"},
        init: function () {
            this.getCartData();
        },
        setQuantity: function (root, input, button, operation, type = null) {
            let context = this;
            let inputQuantity = input != null ? root.parent().find(input) : null;
            let buttonQuantity = button != null ? root.parent().next(button) : null;
            if (inputQuantity !== null) {
                let value = inputQuantity.val() || 1;
                switch (operation) {
                    case 'minus':
                        --value;
                        break;
                    case 'plus':
                        ++value;
                        break;
                }
                value = value < 1 ? 1 : value;
                inputQuantity.val(value);
                if (type === context.types.Dialog) {
                    context.set(context.currentProductId, value, context.currentItem);
                } else if (type === context.types.CartButton) {
                    context.set(context.currentProductId, value, context.currentItem, false);
                } else if (buttonQuantity !== null) {
                    buttonQuantity.attr('data-quantity', value);
                }
            }
        },
        checkInitProduct: function (item, forceUpdate = false) {
            if (Object.keys(this.currentItem).length === 0 || forceUpdate) {
                this.currentItem = item;
                this.currentProductId = item.data('productid') || null;
            }
        },
        setEvents: function () {
            let context = this;
            let $body = $('body');

            $body.off('click', '.add-to-cart, .product-order__addcart');
            $body.on('click', '.add-to-cart, .product-order__addcart', function (e) {
                let item = $(this);
                if (item.attr('href') === '/cart/') {
                    return true;
                }
                if (item.text().trim() === 'Аналог' || item.text().trim() === 'На заказ') {
                    return true;
                }
                e.preventDefault();
                context.add(item.attr('data-productid'), item);
            });
            
            // очистка всей корзины
            $body.on('click', '.cart-items__deleteall', function () {
               context.clear();
            });

            // удаление товара из корзины
            $body.on('click', '.js-cart-item-delete', function () {
                let productId = $(this).data('productid');
                if (productId) {
                    context.del(productId);
                }
                $(this).parents('.js-cart-item').remove();
            });
                
            $body.on('click', '.added-to-cart__counter .js-counter-sub', function () {
                context.checkInitProduct($(this).parent().find('.js-counter-input'));
                context.setQuantity($(this), '.js-counter-input', null, 'minus', context.types.Dialog);
            });

            $body.on('click', '.added-to-cart__counter .js-counter-add', function () {
                context.checkInitProduct($(this).parent().find('.js-counter-input'));
                context.setQuantity($(this), '.js-counter-input', null, 'plus', context.types.Dialog);
            });

            $body.on('click', '.added-to-cart__cart-counter .js-counter-sub', function () {
                context.checkInitProduct($(this).parent().find('.js-counter-input'), true);
                context.setQuantity($(this), '.js-counter-input', null, 'minus', context.types.CartButton);
            });

            $body.on('click', '.added-to-cart__cart-counter .js-counter-add', function () {
                context.checkInitProduct($(this).parent().find('.js-counter-input'), true);
                context.setQuantity($(this), '.js-counter-input', null, 'plus', context.types.CartButton);
            });

            $body.on('click', '.added-to-cart__modification-counter .js-counter-sub', function () {
                context.checkInitProduct($(this).parent().find('.js-counter-input'));
                context.setQuantity($(this), '.js-counter-input', '.add-to-cart', 'minus');
            });

            $body.on('click', '.added-to-cart__modification-counter .js-counter-add', function () {
                context.checkInitProduct($(this).parent().find('.js-counter-input'));
                context.setQuantity($(this), '.js-counter-input', '.add-to-cart', 'plus');
            });

            $body.on('click', '.b-consumable__buy .js-counter-sub', function () {
                context.setQuantity($(this), '.js-counter-input', '.add-to-cart', 'minus');
            });

            $body.on('click', '.b-consumable__buy .js-counter-add', function () {
                context.setQuantity($(this), '.js-counter-input', '.add-to-cart', 'plus');
            });

            $body.on('click', '.js-counter--product .js-counter-sub', function () {
                context.setQuantity($(this), '.js-counter-input', '.product-order__addcart', 'minus');
            });

            $body.on('click', '.js-counter--product .js-counter-add', function () {
                context.setQuantity($(this), '.js-counter-input', '.product-order__addcart', 'plus');            
            });
        },
        getCartData: function () {
            let context = this;
            fetch("/viewcomponent/cart")
                .then(response => response.text())
                .then(result => {
                    context.cart = JSON.parse(result);
                    /*if (context.cart != null) {
                        window.shop.WriteCookie("CartId", context.cart.id, 15, ".mx-zapchasti.ru");
                    }*/
                    context.setEvents();
                    context.refreshCart();
                    context.refreshCounters();
                });
        },
        set: function (productId, quantity, item, showPopup = true) {
            let context = this;
            postDataForm("/cart/set", {
                cartId :context.cart.id,
                productId: productId,
                quantity: quantity
            }).then(result => {
                context.cart = result;
                context.changeCount(item, productId);
                if (showPopup) {
                    context.showPopup(productId);
                }
                context.refreshCart();
            });
        },
        add: function (productId, item) {
            let context = this;
            let quantity = item.attr('data-quantity');
            let mode = item.data('mode') || null;
            const cart = context.cart;
            
            const data = {
                cartId: cart.id,
                productId: productId,
                quantity: quantity
            };
            
            postData("/cart/cart-add", data).then((result) => {
                if(result != null) {
                    context.cart = JSON.parse(result);
                    let items = context.cart.items.filter(function (item) {
                        return item.productId === productId;
                    });
                    if (items.length > 0) {
                        let addedItem = items[0];
                        let eventModel = {
                            id: addedItem.product.id,
                            name: addedItem.product.name,
                            category: addedItem.product.categories[0].name,
                            quantity: addedItem.quantity,
                            price: Math.ceil(addedItem.current)
                        };
                        // SB.ymAddToCart(addedItem.currency.stringCode, eventModel);
                    }
                    context.currentItem = item;
                    context.currentProductId = productId;
                    context.changeCount(item, productId);
                    // if (mode !== "Consumable" && mode !== "ProductCard") {
                    context.showPopup(productId);
                    context.updateCartProducts();
                    // }
                    context.refreshCart();
                }
            }).catch((e) => {
                /* ignored */ 
            });
        },
        del: function (productId) {
            let context = this;
            postDataForm("/cart/del-product", {
                cartId: context.cart.id,
                productId: productId,
            }).then(result => {
                context.cart = JSON.parse(result);
                if (context.cart === null || context.cart.items === undefined || context.cart.items.length === 0) {
                    context.clear();
                }
                context.refreshCart();
                context.refreshCounters();
                context.updateCartAmount();
                // context.updateRelatedSlider();
            });
        },
        clear: function () {
            let context = this;
            postDataForm("/cart/clear", {
                cartId: context.cart.id
            }).then(result => {
                context.cart = JSON.parse(result);
                window.location.reload();
            });
        },
        refreshCart: function () {
            let context = this;
            let container = document.querySelector(".header__cart-wrapper");
            fetch("/viewcomponent/shortcart")
                .then(response => response.text())
                .then(data => {
                    container.innerHTML = data;
                    context.refreshCounters();
                });
        },
        changeCount: function (item, productId) {
            if (item.data('mode') === 'InCart') {
                //item.attr('href', '/cart/');
            }
            item.addClass('add-to-cart--added');
            let count = this.getCount(productId);
            item.find('.add-to-cart__count').each(function () {
                $(this).text(count);
            });
            this.updateCartAmount();
        },
        initRelatedSlider: function (ids) {
            let context = this;
            fetch("/viewcomponent/cartrelatedslider?ids=" + ids)
                .then(response => response.text())
                .then(data => {
                    document.querySelector(".cart__related-slider").innerHTML = data;
                    initSectionSlider();
                    context.refreshCounters();
                });
        },
        updateRelatedSlider: function () {
            if (this.cart == null || this.cart.items === undefined || this.cart.items.length === 0) return;
            let container = document.querySelector(".cart__related-slider");
            if (container) {
                let ids = '';
                this.cart.items.forEach(function (item) {
                   ids += ids === '' ? item.productId : "," + item.productId; 
                });
                fetch("/viewcomponent/cartrelatedslider?ids=" + ids)
                    .then(response => response.text())
                    .then(data => {
                        container.innerHTML = data;
                        initSectionSlider();
                        $.Cart.refreshCounters();
                    });
            }
        },
        updateCartAmount: function () {
            let container = $('.cart-items__total-price');
            if (container) {
                if(!isObject(this.cart)) {
                    this.cart = JSON.parse(this.cart);
                }
                let formattedPrice = `${(this.cart.currentAmount).toLocaleString()} ${container.data('symbol')}`;
                container.text(formattedPrice);
            }  
        },
        showPopup: function (productId) {
            let container = document.querySelector(".added-to-cart__wrapper");
            if (container) {
                addMainBlur();
                fetch("/cart/cart-popup?productId=" + productId)
                    .then(response => response.text())
                    .then(data => container.innerHTML = data)
                    .then(_ => document.querySelector(".added-to-cart").classList.add('is-show'));
            }
        },
        updateCartProducts: function () {
            let container = document.querySelector(".cart__main-wrapper");
            if (container) {
                fetch("/viewcomponent/cartproducts")
                    .then(response => response.text())
                    .then(data => container.innerHTML = data);
            }
            this.updateRelatedSlider();
        },
        refreshCounters: function () {
            let context = this;
            $('.add-to-cart').each(function () {
                let item = $(this);
                let count = context.getCount(item.data('productid'));
                if (count > 0) {
                    context.changeCount(item, item.data('productid'));
                } else {
                    item.removeClass('add-to-cart--added');
                }
            });
            $('.js-counter-input').each(function () {
                let item = $(this);
                let count = context.getCount(item.data('productid'));
                if (count > 0) {
                    item.val(count);
                }
            });

        },
        isExists: function (productId) {
            if (this.cart == null) {
                return false;
            }
            return this.cart.items.some(function (item) {
                return item.productId === productId;
            });
        },
        getCount: function (productId) {
            if (this.cart == null || this.cart.items === undefined) {
                return 0;
            }
            let items = this.cart.items.filter(function (item) {
                return +item.productId === +productId;
            });
            if (items.length > 0) {
                return items[0].quantity;
            }
            return 0;
        }
    };

    $.Cart.init();
});